import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	padding: var(--gap);
	gap: var(--gap);

	.toggle-content {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-small);
		.header {
			display: flex;
			gap: var(--spacing-large);
		}
	}
`;
